import React from 'react';

const InlineLoader = ({ label = 'Cargando datos...' }) => (
  <div className="inline-loader" role="status" aria-live="polite">
    <div className="inline-loader__spinner" aria-hidden="true" />
    <p className="inline-loader__text mb-0">{label}</p>
  </div>
);

export default InlineLoader;
